import { WeezSocket } from "@weezevent/piglet";

export function inIframe() {
    try {
        return window.frameElement || window.self !== window.top || window.parent.location !== window.location;
    } catch (e) {
        return true;
    }
}

export function iframeScrollTo(element) {
    if (inIframe()) {
        const height = element?.getBoundingClientRect()?.top || 0;
        WeezSocket.send({ type: "scrollPageParent", origin: "neo", payload: height });
    }
    if (element)
        element.scrollIntoView({ behavior: "smooth" });
}
